import { GAMIFICATION_ROUTES } from "./gamificationRoutes";
export function buildFriendInviteUrl({ roomCode, categoryId, stateId }) {
  const url = new URL(GAMIFICATION_ROUTES.start, window.location.origin);
  url.searchParams.set("roomCode", String(roomCode));
  url.searchParams.set("categoryId", String(categoryId || 6));
  url.searchParams.set("stateId", String(stateId || 13));
  return url.toString();
}

export async function shareFriendInvitation({ roomCode, categoryId, stateId }) {
  const url = buildFriendInviteUrl({ roomCode, categoryId, stateId });
  const message = `Join my Vidya Kasam battle! Room code: ${roomCode}`;
  if (navigator.share) {
    await navigator.share({ title: "Battle invitation", text: message, url });
    return "Invitation shared.";
  }
  await navigator.clipboard.writeText(`${message}
${url}`);
  return "Invitation link copied.";
}
